// same not good import
import { manageRegistry } from 'config';

export const isGiftCardUpc = (upcNumber) => {
  const { eGiftCardUpcNumber, pGiftCardUpcNumber } = manageRegistry;
  return upcNumber === eGiftCardUpcNumber || upcNumber === pGiftCardUpcNumber;
};

export const isEGiftCardUpc = (upcNumber) => {
  const { eGiftCardUpcNumber } = manageRegistry;
  return upcNumber === eGiftCardUpcNumber;
};

export const isPGiftCardUpc = (upcNumber) => {
  const { pGiftCardUpcNumber } = manageRegistry;
  return upcNumber === pGiftCardUpcNumber;
};

export const updateGiftsAddedCount = (headerData) => {
  const hasGiftCard = headerData.physicalGiftCardEnabled || headerData.egiftCardEnabled;

  if (hasGiftCard && !headerData.giftsAddedUpdated) {
    headerData.giftsAddedUpdated = true;
    headerData.giftsAdded += 1;
  } else if (!hasGiftCard && headerData.giftsAddedUpdated) {
    headerData.giftsAddedUpdated = false;
    headerData.giftsAdded -= 1;
  }

  return headerData;
};

export default {
  isGiftCardUpc,
  isEGiftCardUpc,
  isPGiftCardUpc,
  updateGiftsAddedCount,
};
